import React from "react";
import AccordionContext from "./AccordionContext";

const defaultProps = {
  as: "div",
  toggleable: false,
};

function AccordionCollapse({
  children,
  eventKey,
  toggleable,
  as: Comp,
  ...props
}) {
  const { isOpen } = React.useContext(AccordionContext);
  return (
    <Comp className="collapse" id={eventKey + "-collapse"} {...props}>
      <div className="bg-white rounded-2 overflow-hidden">
        {(!toggleable || isOpen) && children}
      </div>
    </Comp>
  );
}

AccordionCollapse.defaultProps = defaultProps;

export default AccordionCollapse;
